export default "__VITE_ASSET__9b9a8294__"